export const GET_BANKS = 'GET_BANKS';
export const BANK_REQUEST = 'BANK_REQUEST';
export const CREATE_BANK = 'CREATE_BANK';
export const UPDATE_BANK = 'UPDATE_BANK';
export const DELETE_BANK = 'DELETE_BANK';
export const BANK_REQUEST_FAILURE = 'BANK_REQUEST_FAILURE';
export const GET_BANKS_PAGE = 'GET_BANKS_PAGE';
export const BANK_REQUEST_SUCCESS = 'BANK_REQUEST_SUCCESS';